{
	"name": "yf-commerce-backoffice2",
	"version": "20.0.10",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"start_ocarina_dev": "ng serve --proxy-config proxy/proxy.ocarina.dev.conf.json --configuration development",
		"start_gimetal_dev": "ng serve --proxy-config proxy/proxy.gimetal.dev.conf.json --configuration gimetal_dev",
		"start_unisafety_dev": "ng serve --proxy-config proxy/proxy.unisafety.dev.conf.json --configuration unisafety_dev",
		"i18n:init": "ngx-translate-extract --input ./src --output ./src/assets/i18n/template.json --key-as-default-value --replace --format json",
		"i18n:extract": "ngx-translate-extract --input ./src --output ./src/assets/i18n/{en,it}.json --sort --sort-sensitivity base --format json --format-indentation '  '",
		"builddemo": "ng build --configuration demo",
		"buildocarina": "ng build --configuration ocarina",
		"buildgimetaldev": "ng build --configuration gimetal_dev",
		"buildunisafetydev": "ng build --configuration unisafety_dev",
		"build-stage": "ng build --configuration production --base-href /angular/stage/",
		"build-prod": "ng build --configuration production --base-href /angular/default/",
		"build": "ng build",
		"watch": "ng build --watch --configuration development",
		"test": "ng test",
		"lint": "ng lint",
		"lint:fix": "ng lint --fix",
		"prettier": "prettier --write ./src"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "^20.3.9",
		"@angular/cdk": "^20.2.10",
		"@angular/common": "^20.3.9",
		"@angular/compiler": "^20.3.9",
		"@angular/core": "^20.3.9",
		"@angular/forms": "^20.3.9",
		"@angular/localize": "^20.3.9",
		"@angular/material": "^20.2.10",
		"@angular/material-moment-adapter": "^20.2.10",
		"@angular/platform-browser": "^20.3.9",
		"@angular/platform-browser-dynamic": "^20.3.9",
		"@angular/router": "^20.3.9",
		"@circlon/angular-tree-component": "^11.0.4",
		"@ng-bootstrap/ng-bootstrap": "^19.0.1",
		"@ngx-translate/core": "16.0.4",
		"@ngx-translate/http-loader": "^16.0.1",
		"@popperjs/core": "^2.11.8",
		"@stripe/stripe-js": "^7.8.0",
		"@swimlane/ngx-datatable": "^21.1.13",
		"@tinymce/tinymce-angular": "^8.0.1",
		"@types/jquery": "^3.5.33",
		"angular-imask": "^7.6.1",
		"animate.css": "4.1.1",
		"bootstrap": "^5.3.7",
		"class-transformer": "^0.5.1",
		"dayjs": "^1.11.13",
		"elbuild-pipeline-utils": "^0.2.235",
		"elbuild-ui-componentslib": "20.0.48",
		"elbuild-ui-lib-core": "20.0.48",
		"elbuild-ui-paymentslib": "20.0.48",
		"famfamfam-flags": "^1.0.0",
		"font-awesome-filetypes": "^2.1.0",
		"guid-typescript": "^1.0.9",
		"humanize-duration-ts": "^2.1.1",
		"jquery": "^3.7.1",
		"jwt-decode": "^4.0.0",
		"lodash": "4.17.21",
		"moment": "2.30.1",
		"ngx-color": "^10.0.0",
		"ngx-cookie-service": "^19.0.1",
		"ngx-device-detector": "^10.0.2",
		"ngx-lightbox": "^3.0.0",
		"ngx-paypal": "^11.0.0",
		"ngx-scrollbar": "^18.0.0",
		"ngx-skeleton-loader": "^11.2.1",
		"ngx-stripe": "^20.7.0",
		"ngx-summernote": "^1.0.0",
		"ngx-toastr": "^19.0.0",
		"ngx-translate": "^0.0.1-security",
		"ngx-uploader": "^17.0.1",
		"ngx-webstorage-service": "^5.0.0",
		"primeng": "^20.0.1",
		"rxjs": "~7.8.1",
		"strip_tags": "^1.0.1",
		"summernote": "^0.9.1",
		"ts-md5": "^1.3.1",
		"uploader": "3.48.3",
		"yf-commerce-model-ui-lib": "1.0.87",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-eslint/builder": "19.0.2",
		"@angular-eslint/eslint-plugin": "19.0.2",
		"@angular-eslint/eslint-plugin-template": "19.0.2",
		"@angular-eslint/schematics": "19.0.2",
		"@angular-eslint/template-parser": "19.0.2",
		"@angular/build": "^20.3.8",
		"@angular/cli": "20.3.8",
		"@angular/compiler-cli": "20.3.9",
		"@eslint/eslintrc": "3.2.0",
		"@eslint/js": "9.17.0",
		"@types/lodash": "4.17.13",
		"@typescript-eslint/eslint-plugin": "8.18.2",
		"@typescript-eslint/parser": "8.18.2",
		"@vendure/ngx-translate-extract": "^9.4.2",
		"eslint": "9.17.0",
		"fs-extra": "^11.3.0",
		"git-describe": "^4.1.1",
		"minimist": "^1.2.8",
		"prettier": "3.4.2",
		"tslib": "^2.8.1",
		"typescript": "5.9.3"
	}
}
